import React, { createContext, useContext } from "react";
import { useZitadelAuth } from "hooks/auth/auth";

const AuthContext = createContext(null);

export function AuthProvider({ config, children }) {
  const auth = useZitadelAuth(config);
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth must be used inside an AuthProvider");
  }
  return ctx;
}
